export default "__VITE_ASSET__BOUsPFN1__"